import React from "react";
import styles from "./MuseumCard.module.scss";
import museumImage from "../../../assets/images/museum-image.jpg";

const MuseumCard = () => {
  return (
    <div className={styles.card} onClick={() => console.log("Card clicked.")}>
      <div className={styles.mainImage}>
        <img src={museumImage} alt="Museum Name" />
      </div>
      <div className={styles.otherImages}>
        <div>
          <img src={museumImage} alt="Museum Name" />
        </div>
        <div>
          <img src={museumImage} alt="Museum Name" />
        </div>
        <div>
          <img src={museumImage} alt="Museum Name" />
        </div>
      </div>
      <h2 className={styles.title}>Museum Name</h2>
    </div>
  );
};

export default MuseumCard;
